import React from 'react';
import { motion } from 'framer-motion';
import * as FiIcons from 'react-icons/fi';
import SafeIcon from '../common/SafeIcon';
import { useLanguage, translations } from '../context/LanguageContext';

const { FiBook, FiSun, FiMoon } = FiIcons;

const Header = ({ currentDate }) => {
  const { language } = useLanguage();
  const t = translations[language];

  const formatDate = (date) => {
    return date.toLocaleDateString(language === 'de' ? 'de-DE' : 'en-US', {
      weekday: 'long',
      year: 'numeric',
      month: 'long',
      day: 'numeric'
    });
  };

  const getGreeting = () => {
    const hour = new Date().getHours();
    if (hour >= 17) return { text: t.goodEvening, icon: FiMoon };
    if (hour >= 12) return { text: t.goodAfternoon, icon: FiSun };
    return { text: t.goodMorning, icon: FiSun };
  };

  const greeting = getGreeting();

  return (
    <motion.header
      initial={{ opacity: 0, y: -20 }}
      animate={{ opacity: 1, y: 0 }}
      className="text-center mb-6 lg:mb-8"
    >
      <div className="bg-white/10 backdrop-blur-md rounded-2xl p-6 lg:p-8 border border-white/20">
        <div className="flex flex-col sm:flex-row items-center justify-center mb-4">
          <SafeIcon icon={FiBook} className="text-3xl lg:text-4xl text-purple-300 mb-2 sm:mb-0 sm:mr-4" />
          <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-white text-center sm:text-left">
            {t.journalTitle}
          </h1>
        </div>
        
        <div className="flex items-center justify-center text-purple-200 mb-2">
          <SafeIcon icon={greeting.icon} className="text-lg lg:text-xl mr-2" />
          <span className="text-lg lg:text-xl">{greeting.text}</span>
        </div>
        
        <p className="text-purple-100 text-base lg:text-lg opacity-90 mb-4">
          {formatDate(currentDate)}
        </p>
        
        <div className="text-purple-200/80 text-sm lg:text-base italic px-4">
          "{t.journalQuote}"
        </div>
      </div>
    </motion.header>
  );
};

export default Header;